<div class="main-container">
  <app-header class="header"></app-header>
  <app-sidenav class="sidenav"></app-sidenav>

  <div class="main-container-content">
    <div class="content">
      <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
      <router-outlet *ngIf="!isIframe"></router-outlet>
    </div>
  </div>
</div>
